import React from "react";
import { Main } from "../components/main";

const Home = () => {
  return <Main/>
};

export { Home };